import BaseUseCase from "../../../base_use_case.js";

class SetProjectUseCase extends BaseUseCase {

  execute(identifier, status) {
    let params = {
      findBySlug: true,
      project: {
        status: status
      }
    }
    return this.httpClient({
      ...this.requestConfig(),
      method: "put",
      url: `/api/v1/admin/projects/projects/${identifier}/status`,
      data: params,
    });
  }
}

const instance = new SetProjectUseCase();
export default instance;